<template>
  <v-container>
    <v-tabs v-model="tab" vertical>
      <v-tab key="general">{{$t('general')}}</v-tab>
      <v-tab key="query">{{$t('entities.report.props.query')}}</v-tab>
      <v-tab key="params">{{$tc('entities.report.props.params',2)}}</v-tab>
      <v-tab key="font">{{$t('entities.report.props.font')}}</v-tab>

      <v-tabs-items v-model="tab">
        <v-tab-item key="general">
          <v-form ref="generalForm">
            <v-text-field
              :label="$t('entities.report.props.description')"
              :rules="$isRequiredRule"
              v-model="value.description"
              clearable
            ></v-text-field>
          </v-form>
        </v-tab-item>
        <v-tab-item key="query" eager>
          <v-form ref="queryForm">
            <v-textarea
              :label="$t('entities.report.props.query')"
              :rules="$isRequiredRule"
              v-model="value.query"
              clearable
            ></v-textarea>
          </v-form>
        </v-tab-item>

        <v-tab-item key="params" eager>
          <report-params-tab v-model="value.params"></report-params-tab>
        </v-tab-item>

        <v-tab-item key="font" eager>
          <v-form ref="fontForm">
            <v-textarea
              :label="$t('entities.report.props.font')"
              :rules="$isRequiredRule"
              v-model="value.font"
              clearable
            ></v-textarea>
          </v-form>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-container>
</template>

<script>
import formValidationMixin from "@/mixins/formValidationMixin.js";
import reportParamsTab from "./reportParamsTab";
export default {
  name: "report-form",
  mixins: [formValidationMixin],
  components: { reportParamsTab },
  props: {
    value: {
      params: [],
      description: "",
      query: ""
    }
  },

  data() {
    return {
      tab: null
    };
  },
  methods: {
    resetValidation() {
      this.$refs.generalForm.resetValidation();
      this.$refs.queryForm.resetValidation();
      this.$refs.fontForm.resetValidation();
    },
    validate() {
      let refGeneralIsValid = this.$refs.generalForm.validate();
      let refQueryIsValid = this.$refs.queryForm.validate();
      let refFontIsValid = this.$refs.fontForm.validate();

console.log((
        refGeneralIsValid == true &&
        refQueryIsValid == true &&
        refFontIsValid == true
      ))
      return (
        refGeneralIsValid == true &&
        refQueryIsValid == true &&
        refFontIsValid == true
      );
    },
    isValid() {
      return this.validate();
    }
  }
};
</script>
